import React from "react";

export default function Footer() {
  return (
    <footer className="ft">
      World Highpoint Guide ·{" "}
      Created by Jeffery Mei ·{" "}
      Inspired by <a href="https://highpoint.guide" target="_blank" rel="noopener noreferrer">highpoint.guide</a>
    </footer>
  );
}
